import { createAction } from 'typesafe-actions';

import {GetEmployeeDataPayload, SetEmployeeDataPayload} from "./employeeData.types";

export const setEmployeeData = createAction('SET_EMPLOYEE_DATA')<SetEmployeeDataPayload>();

export const getEmployeeData = createAction('GET_EMPLOYEE_DATA')<GetEmployeeDataPayload>();
